import React from 'react';
import SharedConfiguredDashboardPage from 'src/mtska-frontend-modules/modules/_shared/dashboardConfigured/ConfiguredDashboardPage';
import { filtersTransformRegistry } from './reportRegistry';

const ConfiguredDashboardPage = (props) => (
    <SharedConfiguredDashboardPage {...props} filtersTransformRegistry={filtersTransformRegistry} showFilterSetLabel />
);

export default ConfiguredDashboardPage;
